"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Hr = _interopRequireDefault(require("elevate-ui/Hr"));

var HorizontalRulePreview = function HorizontalRulePreview(_ref) {
  var _ref$content$attrs = _ref.content.attrs,
      color = _ref$content$attrs.color,
      thickness = _ref$content$attrs.thickness;
  return /*#__PURE__*/_react["default"].createElement(_Hr["default"], {
    color: color || "primary",
    thickness: parseInt(thickness) || 2,
    style: {
      margin: "0 auto",
      minWidth: "25px"
    }
  });
};

var _default = HorizontalRulePreview;
exports["default"] = _default;